<div class="container-fluid">
    <div class="row">
        <div class="col-md-3" *ngIf="showSideMenu">
            <a routerLink="/naac/ssr/criteria3"> <i class="fas fa-long-arrow-alt-left"></i> Go Back</a>
            <nav id="secondary-navigation">
                <!-- Header -->
                <header class="header">
                    <h5>3.3</h5>
                </header>
                <!-- /Header -->
                <ul>
                    <li routerLinkActive="active">
                        <a  routerLink="/naac/ssr/criteria3/3-3/3-3-1" (click)="checkRoute()">3.3.1</a>
                    </li>
                    <li routerLinkActive="active">
                        <a  routerLink="/naac/ssr/criteria3/3-3/3-3-2" (click)="checkRoute()">3.3.2</a>
                    </li>
                </ul>
            </nav>
        </div>
        <div class="col-md-9" *ngIf="showHeading">
            <h4 class="text-center">Research Publication & Awards</h4>
        </div>
        <div [ngClass]="fullWidth ? 'col-md-12' : 'col-md-9'">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>